import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { IconButton, Typography, Paper, Divider } from "@mui/material";
import Grid from "@mui/material/Grid";

export const WmsPoPhysicalStockCountDetailTblCard = ({
  data = [],
  onClick = () => {},
  onDelete = () => {},
  vRdxHead,
}) => {
  return (
    <Grid container spacing={0.8} className="easy-putaway-container mt-1">
      {data.map((item, index) => (
        <Grid item xs={12} key={index}>
          <Paper
            elevation={3}
            sx={{
              p: 1,
              borderRadius: 2,
              border: 1,
              borderColor: "primary.light",
              position: "relative",
              backgroundColor: "#f9f9f9",
              cursor: "pointer",
            }}
            onClick={() => onClick({ row: item })}
          >
            {/* Grid content */}
            <Grid container spacing={0.1}>
              {[
                // { label: "Sheet No", value: item.B_SheetId },
                { label: "Card ID", value: item.B_CardID },
                { label: "Bin Name", value: item.BinName },
                { label: "Qty", value: item.B_Qty },
                { label: "Unit", value: item.B_Unit },
                { label: "Base Qty", value: item.B_BaseQty },
              ].map((field, i) => (
                <Grid item xs={6} sm={4} md={3} key={i}>
                  <Typography variant="subtitle2" color="text.secondary">
                    {field.label}
                  </Typography>
                  <Typography variant="body1" fontWeight="500">
                    {field.value || "-"}
                  </Typography>
                </Grid>
              ))}
            </Grid>

            {/* <Divider sx={{ my: 1 }} /> */}

            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{ px: 1 }}
            >
              {/* <Grid item xs>
                <Typography variant="body2" fontWeight={600} textAlign="center">
                  {item.ItmName}
                </Typography>
              </Grid> */}

              {vRdxHead.A_DocStat === "ENTER" && (
                <Grid item>
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(item);
                    }}
                    size="small"
                    sx={{
                      backgroundColor: "#ffe6e6",
                      "&:hover": {
                        backgroundColor: "#ffcccc",
                      },
                    }}
                  >
                    <DeleteRoundedIcon fontSize="small" color="error" />
                  </IconButton>
                </Grid>
              )}
            </Grid>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};
